import React, { useState, useEffect } from "react";
//import { useSelector } from "react-redux";
import { useGetRelanceDevis } from "../services/RelanceDevisService";
import * as LoadingIcons from "react-loading-icons";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const RelanceDevisList = () => {
    //const token = useSelector((state) => state.auth.token);
    const {
        relances,
        loading,
        pagination,
        page,
        setPage,
        fetchRelances,
    } = useGetRelanceDevis();

    const [selectedMessage, setSelectedMessage] = useState(null);

    useEffect(() => {
        fetchRelances(page);
    }, [page, fetchRelances]);

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= pagination.last_page) setPage(newPage);
    };

    return (
        <section className="pb-4 flex flex-col gap-4 px-4 w-full">
            <ToastContainer position="top-right" autoClose={3000} />

            {loading ? (
                <div className="flex justify-center items-center h-[400px]">
                    <LoadingIcons.SpinningCircles stroke="#2218eeff" height={40} width={40} />
                </div>
            ) : relances && relances.length > 0 ? (
                relances.map((r, index) => (
                    <div
                        key={r.id}
                        className="bg-white shadow-md rounded-xl p-4 flex flex-col gap-2 border border-gray-200"
                    >
                        {/* Client + Devis */}
                        <div className="flex flex-col md:flex-row justify-between gap-2">
                            <div>
                                <h2 className="font-semibold text-lg">{r.devis?.client?.nom_affichage || "Client inconnu"}</h2>
                                <p className="text-sm text-gray-600">{r.devis?.client?.email || "-"}</p>
                                <p className="text-sm text-gray-600">{r.devis?.client?.telephone || "-"}</p>
                            </div>

                            <div className="flex flex-col md:items-end gap-1">
                                <span className="bg-blue-100 text-blue-800 px-2 py-1 rounded font-medium">
                                    Devis: {r.devis?.numero || "-"}
                                </span>
                                <span>Total TTC: {r.devis ? (r.devis.total_centimes / 100).toFixed(2) + " " + r.devis.devise : "-"}</span>
                                <span>Date émission: {r.devis?.date_emission || "-"}</span>
                            </div>
                        </div>

                        {/* Relances */}
                        <div className="mt-2">
                            <h3 className="font-semibold">Relances :</h3>
                            {r.message ? (
                                <div className="flex flex-col gap-1 mt-1">
                                    <div className="flex justify-between items-center bg-gray-50 border border-gray-200 rounded px-2 py-1">
                                        <span>Date: {new Date(r.date_relance).toLocaleDateString()}</span>
                                        <button
                                            onClick={() => setSelectedMessage(r.message)}
                                            className="text-blue-600 hover:underline text-sm"
                                        >
                                            Voir message
                                        </button>
                                    </div>
                                </div>
                            ) : (
                                <p className="text-gray-500 text-sm mt-1">Aucune relance pour le moment.</p>
                            )}
                        </div>

                        {/* Bouton relancer */}
                        <div className="mt-2">
                            <button className="bg-green-600 hover:bg-green-700 text-white px-3 py-1 rounded text-sm">
                                Relancer
                            </button>
                        </div>
                    </div>
                ))
            ) : (
                <p className="text-center text-gray-500 mt-4">Aucune relance devis trouvée.</p>
            )}

            {/* Pagination */}
            <div className="flex justify-center items-center gap-3 mt-4">
                <button
                    disabled={pagination.current_page === 1}
                    onClick={() => handlePageChange(pagination.current_page - 1)}
                    className={`px-4 py-1 rounded-lg text-white text-sm font-semibold ${pagination.current_page === 1 ? "bg-gray-400 cursor-not-allowed" : "bg-color1 hover:bg-color6 cursor-pointer"}`}
                >
                    Précédent
                </button>
                <span className="text-gray-700 font-medium text-sm">
                    {pagination.current_page} / {pagination.last_page}
                </span>
                <button
                    disabled={pagination.current_page === pagination.last_page}
                    onClick={() => handlePageChange(pagination.current_page + 1)}
                    className={`px-4 py-1 rounded-lg text-white text-sm font-semibold ${pagination.current_page === pagination.last_page ? "bg-gray-400 cursor-not-allowed" : "bg-color1 hover:bg-color6 cursor-pointer"}`}
                >
                    Suivant
                </button>
            </div>

            {/* Popup message */}
            {selectedMessage && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="bg-white rounded-lg shadow-lg p-4 max-w-lg w-full relative">
                        <button
                            onClick={() => setSelectedMessage(null)}
                            className="absolute top-2 right-2 text-gray-700 font-bold text-lg"
                        >
                            X
                        </button>
                        <h3 className="font-semibold mb-2">Message envoyé au client :</h3>
                        <p className="text-gray-700">{selectedMessage}</p>
                    </div>
                </div>
            )}
        </section>
    );
};

export default RelanceDevisList;
